"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTag", {
  enumerable: true,
  get: function get() {
    return _SVBTags.default;
  }
});
var _SVBTags = _interopRequireDefault(require("./src/SVBTags"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }